<div class="application-view-main-container application-view-main-container-narrower">
    <div class="texts-container">
        <p class="landing-page-text text-centered text-primary-color">Regulaminy:</p>
        <span class="statute-text" (click)="downloadPdf('regulamin_promocji_klimatyzacja')">1. Regulamin promocji "Klimatyzacja Panasonic"</span>
        <span class="statute-text" (click)="downloadPdf('regulamin_promocji_pomp_ciepła')">2. Regulamin promocji "Pompy ciepła Panasonic"</span>
    </div>
</div>